module.exports = "<div class=\"bv-reviews-container\">\n  <div id=\"bvApiJs\"></div>\n  <div id=\"BVSubmissionContainer\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/bv-reviews/bv-reviews.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/bv-reviews/bv-reviews.component.html
// module chunks = 0